/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { tunneledMcpUpdateServer } from "../funcs/tunneledMcpUpdateServer.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { TunneledMcpServer } from "../models/components/tunneledmcpserver.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateTunneledMcpServerRequest,
  UpdateTunneledMcpServerSecurity,
} from "../models/operations/updatetunneledmcpserver.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateTunneledMcpServerMutationVariables = {
  request: UpdateTunneledMcpServerRequest;
  security?: UpdateTunneledMcpServerSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateTunneledMcpServerMutationData = TunneledMcpServer;

export type UpdateTunneledMcpServerMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateServer tunneledMcp
 *
 * @remarks
 * Update a tunneled MCP server source
 */
export function useUpdateTunneledMcpServerMutation(
  options?: MutationHookOptions<
    UpdateTunneledMcpServerMutationData,
    UpdateTunneledMcpServerMutationError,
    UpdateTunneledMcpServerMutationVariables
  >,
): UseMutationResult<
  UpdateTunneledMcpServerMutationData,
  UpdateTunneledMcpServerMutationError,
  UpdateTunneledMcpServerMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateTunneledMcpServerMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateTunneledMcpServer(): MutationKey {
  return ["@gram/client", "tunneledMcp", "updateServer"];
}

export function buildUpdateTunneledMcpServerMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateTunneledMcpServerMutationVariables,
  ) => Promise<UpdateTunneledMcpServerMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateTunneledMcpServer(),
    mutationFn: function updateTunneledMcpServerMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateTunneledMcpServerMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(tunneledMcpUpdateServer(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
